<template>
  <div class="Timer clearfix" v-if="endTimes">
    <span class="timer_description">考试剩余时间：</span>
    <span class="timer_data">{{ remainingTime | timeFilter }}</span>
  </div>
</template>
<script>
  export default {
    name: 'Timer',
    props: {
      endTimes: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        countDown: null,
        remainingTime: 0
      }
    },
    watch: {
      endTimes(newVal) {
        if (newVal <= 0) {
          clearInterval(this.countDown)
          this.$emit('submit')
        } else {
          this.remainingTime = newVal
        }
      }
    },
    mounted() {
      this.remainingTime = this.endTimes || 60
      this.countDown = setInterval(() => {
        this.remainingTime--
        this.$emit('update:endTimes', this.remainingTime)
      }, 1000)
    },
    beforeDestroy() {
      clearInterval(this.countDown)
    },
    stopTimer() {
      if(this.countDown != null) {
        clearInterval(this.countDown)
        this.countDown = null
      }
    }
  }
</script>
<style lang="scss" scoped>
  .Timer {
    float: right;
    height: 33px;
    margin-right: 20px;

    .timer_description {
      float: left;
      height: 33px;
      line-height: 33px;
      color: #023996;
      font-size: 14px;
      font-weight: 700;
      display: inline-block;
    }

    .timer_data {
      float: left;
      display: inline-block;
      font-size: 21px;
      color: red;
      height: 33px;
      line-height: 30px;
      font-weight: 400;
    }
  }
</style>
